import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dairectArrowUpRight from "../../../assets/img/icons/dairect-arrow-up-right.svg";
import dairectMonogramDesktop from "../../../assets/img/icons/dairect-monogram-desktop.svg";
import dairectMonogramMobile from "../../../assets/img/icons/dairect-monogram-mobile.svg";
import { fireTagManagerEvent } from "../../../assets/Services/tagmanager";
import { selectUser } from "../../../redux/slices/userSlice";
import { buildDairectUrl } from "../../helpers/dairect";
import StaticPageBackground from "./StaticPageBackground";

export default function HomeRebranding() {
  const { t, i18n } = useTranslation();
  const user = useSelector(selectUser);

  useEffect(() => {
    fireTagManagerEvent("landing_view", {
      user_id: user?._id ?? null,
      page_variant: "rebrand_hero",
    });
  }, [user?._id]);

  const openDairect = (campaign: string) => {
    const dairectUrl = buildDairectUrl({
      campaign,
      locale: i18n.language,
      medium: "homepage",
    });

    window.open(dairectUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      className="relative isolate flex h-[100dvh] flex-col items-center justify-center overflow-hidden bg-[#091112]"
      aria-label="dAirect rebranding hero"
    >
      <StaticPageBackground variant="dark" />

      <div className="relative z-[2] mx-auto flex w-full flex-col items-center justify-center gap-[30px] text-center">
        <img
          src={dairectMonogramMobile}
          alt=""
          className="h-20 w-[73px] lg:hidden"
          aria-hidden="true"
        />
        <img
          src={dairectMonogramDesktop}
          alt=""
          className="hidden h-[100px] w-[92px] lg:block"
          aria-hidden="true"
        />

        <div className="flex w-full flex-col items-center justify-center gap-4">
          <h1 className="m-0 w-full [font-family:'Geist',_sans-serif] text-[30px] font-medium leading-[32px] tracking-[-0.9px] text-white lg:text-[48px] lg:leading-[52px] lg:tracking-[-1.44px]">
            {t("ds.home_rebrand_title")}
          </h1>
          <p className="m-0 w-full max-w-[422px] [font-family:'Geist',_sans-serif] text-[16px] font-normal leading-[22px] tracking-[-0.32px] text-white/60 lg:text-[18px] lg:leading-[24px] lg:tracking-[-0.36px]">
            {t("ds.home_rebrand_subtitle")}
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 lg:flex-row">
          <button
            type="button"
            className="order-[-1] inline-flex min-h-12 items-center justify-center gap-[6px] whitespace-nowrap rounded-2xl border-2 border-white/20 bg-[#9afee3] px-4 py-3 [font-family:'Geist',_sans-serif] text-[16px] font-medium leading-6 text-[#0a1213] shadow-[0_0_10px_rgba(154,255,228,0.4)] transition-opacity hover:opacity-90 lg:order-none"
            onClick={() => openDairect("go_to_dairect")}
          >
            <span>{t("ds.home_rebrand_cta_primary")}</span>
            <img
              src={dairectArrowUpRight}
              alt=""
              aria-hidden="true"
              className="h-5 w-5"
            />
          </button>
        </div>
      </div>
    </section>
  );
}
